import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { Toaster } from '@/components/ui/sonner';

// Layout
import Header from './components/Header';
import Footer from './components/Footer';

// Pages
import HomePage from './pages/HomePage';
import SuiviChantierPage from './pages/SuiviChantierPage';
import GalleryPage from './pages/GalleryPage';
import DevisPage from './pages/DevisPage';
import FAQPage from './pages/FAQPage';
import AboutPage from './pages/AboutPage';
import MentionsLegalesPage from './pages/MentionsLegalesPage';
import POCPage from './pages/POCPage';
import ServicesLandingPage from './pages/ServicesLandingPage';

// Service Pages
import RenovationCompletePage from './pages/services/RenovationCompletePage';
import SalleDeBainPage from './pages/services/SalleDeBainPage';
import CuisinePage from './pages/services/CuisinePage';
import Plans3DPage from './pages/services/Plans3DPage';

export default function App() {
  return (
    <div className="App">
      <Router>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/suivi-de-chantier" element={<SuiviChantierPage />} />
            <Route path="/galerie-avant-apres" element={<GalleryPage />} />
            <Route path="/devis" element={<DevisPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/a-propos" element={<AboutPage />} />
            <Route path="/mentions-legales" element={<MentionsLegalesPage />} />
            <Route path="/cgv" element={<MentionsLegalesPage />} />
            
            {/* Services */}
            <Route path="/services" element={<ServicesLandingPage />} />
            <Route path="/services/renovation-complete" element={<RenovationCompletePage />} />
            <Route path="/services/salle-de-bain" element={<SalleDeBainPage />} />
            <Route path="/services/cuisine" element={<CuisinePage />} />
            <Route path="/services/plans-3d" element={<Plans3DPage />} />
            <Route path="/services/suivi-chantier" element={<SuiviChantierPage />} />
            
            {/* POC */}
            <Route path="/poc" element={<POCPage />} />
          </Routes>
        </main>
        <Footer />
      </Router>
      <Toaster position="top-right" richColors />
    </div>
  );
}